<ion-content [fullscreen]="true">
  <div (click)="modalCtrl.dismiss()"
    style="display: flex; align-items: center; padding: 16px; gap: 10px; border-bottom: 1px solid #E4E0EB;">
    <ion-icon style="font-size: 25px; color: #1E1725; cursor: pointer" name="chevron-back-outline"></ion-icon>
    <div style="width: calc(100% - 70px); color: #1E1725; padding-top: 2px;" class="body-md-semibold">
      Manage DNS
    </div>
  </div>

  <app-loading *ngIf="isLoading === true"></app-loading>


  <div *ngIf="isLoading === false" style="padding: 10px 15px 18px 15px;">
    <app-selection-field (valueChange)="validator = {}" bindLabel="type" bindValue="type" [filter]="false"
      [options]="type" [validator]="validator['type']" title="Type" [model]="details" placeholder="Select type"
      field="type">
    </app-selection-field>

    <app-input-field type="text" [validator]="validator['name']" [(ngModel)]="details['name']" placeholder="Enter name"
      title="Name">
    </app-input-field>

    <app-selection-field (valueChange)="validator = {}" bindLabel="label" bindValue="value" [filter]="false"
      [options]="ttlOptions" [validator]="validator['ttl']" title="TTL" [model]="details"
      placeholder="Select TTL" field="ttl">
    </app-selection-field>

    <app-input-field type="number" *ngIf="details['type'] === 'MX'" [validator]="validator['priority']"
      [(ngModel)]="details['priority']" placeholder="Enter Priority" title="Priority">
    </app-input-field>

    <app-input-field *ngIf="details['type'] === 'SRV'" [validator]="validator['data']?.['priority'] || {}"
      [(ngModel)]="details['data']['priority']" placeholder="10" title="Priority">
    </app-input-field>

    <app-input-field *ngIf="details['type'] === 'SRV'" [validator]="validator['data']?.['weight'] || {}"
      [(ngModel)]="details['data']['weight']" placeholder="5" title="Weight">
    </app-input-field>

    <app-input-field *ngIf="details['type'] === 'SRV'" [validator]="validator['data']?.['port'] || {}"
      [(ngModel)]="details['data']['port']" placeholder="5060" title="Port">
    </app-input-field>

    <app-input-field *ngIf="details['type'] === 'SRV'" [validator]="validator['data']?.['target'] || {}"
      [(ngModel)]="details['data']['target']" placeholder="Hostname" title="Target">
    </app-input-field>

    <app-input-field *ngIf="details['type'] !== 'SRV'" [validator]="validator['content']"
      [(ngModel)]="details['content']" [placeholder]="typeObj[details['type']]['placeholder']"
      [title]="typeObj[details['type']]['title']">
    </app-input-field>

    <div style="display: flex; gap: 12px; justify-content: flex-end;">
      <div class="button body-sm-medium" style="background-color: #E4E0EB; border: none; color: black;"
        (click)="modalCtrl.dismiss()">
        Cancel
      </div>
      <div (click)=" createDns()" class="button body-sm-medium">Confirm
      </div>

    </div>
  </div>


</ion-content>
